/** A successful planning Start can introduce production without blocking planning. */
export const PRODUCTION_START_EVENT = '8080:planning-start-accepted';

export interface ProductionStartEvent {
  projectId: string;
  startKey: string;
}

export const notifyProductionStart = (detail: ProductionStartEvent): void => {
  window.dispatchEvent(new window.CustomEvent<ProductionStartEvent>(PRODUCTION_START_EVENT, { detail }));
};
